import Mutations from './mutations.js'
import Actions from './actions.js'
import Getters from './getters.js'

export default {
    namespaced:true,
    state(){
        return {
            activeMenu:'',
            activeSubMenu:'',
            activeMobileMenu:'m_Home',
            swiperIndexHome:0,
            swiperIndexItem:0,
            viewPost:[],
            sameMenu:false,//같은 메뉴를 클릭하고 있는걸 감지 하기 위해
            menus:[],
            documents:[],
            searchpost_userId:'',
            searchpost_content:'',
        }
    },
    mutations:Mutations,
    actions:Actions,
    getters:Getters
}
